import { Contact } from '@features/contacts/types/contact'
import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { ContactForm } from './formData'
import { getCreateSupplierPayload } from './getCreateSupplierPayload'

export const getCreateContactPayload = (
  contactForm: ContactForm,
  isSupplier: boolean,
  organization?: Organization,
): Partial<Contact> => (isSupplier ? getCreateSupplierPayload(contactForm, organization) : {})
